import { get, post } from './client.js';
const base = (wsId) => `/workspaces/${wsId}/health-scores`;
export const list         = (wsId, entityType)              => get(base(wsId), { params: entityType ? { entityType } : {} });
export const getScore     = (wsId, entityType, entityId)    => get(`${base(wsId)}/${entityType}/${entityId}`);
export const compute      = (wsId, entityType, entityId)    => post(`${base(wsId)}/compute`, { entityType, entityId });
export const batchCompute = (wsId)                          => post(`${base(wsId)}/batch-compute`);
